export class Cargo {
  id!: number;
  descricao!: string;
  situacao!: string;
  situacaoF!: boolean;
}
